import { render, staticRenderFns } from "./rolePropertyEdit.vue?vue&type=template&id=2bfdcf09&"
import script from "./rolePropertyEdit.vue?vue&type=script&lang=js&"
export * from "./rolePropertyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports